module.exports = __webpack_public_path__ + "VIPV20.png?cc7b9e56e2799fbaeb03f19e20e34d20";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV20.png
// module id = 115
// module chunks = 0